import { NavigationVariants } from '@anm/components/header';
import { FC } from 'react';

import Header from '../../templates/Header';
import Layout from '../Layout';

import { HeaderWrapper, Main } from './Wrapper';
export * from './Wrapper';

type LayoutProps = {
  navigationVariant?: NavigationVariants;
};

const VideoTemplatesLayout: FC<LayoutProps> = ({ children, navigationVariant }) => (
  <Layout footerVariant="big" {...{ navigationVariant }}>
    <HeaderWrapper size={2000}>
      <Header />
    </HeaderWrapper>
    <Main>{children}</Main>
  </Layout>
);

export default VideoTemplatesLayout;
